<template>
<main>
  <div class="container-fluid pt-3">
    <div class="card shadow-lg ">
      <div class="card-body p-3">
        <div class="row gx-4">
          <div class="col my-auto">
            <div id="tree" ref="tree"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>


</template>

<script>


const CryptoJS = require("crypto-js");
const OrgChart = require("@balkangraph/orgchart.js")

export default {
  name: 'tree',
  data() {
    return {
      nodes: [],
      tree_list : [],
      tree : '',
    }
  },
  methods: {
    GetTreeList(){

      this.axios.post('/admin/organization/GetRecomList', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res);
              this.nodes = body.list;
              this.checkNode();
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }else{
            this.loading = false;
          }
        }
      )
    },
    checkNode : function(){
      for (var i = 0; i < this.nodes.length; i++) {
        var node = this.nodes[i];
        switch (node.직급) {
          case "일반":
            node.tags = ["STAR_0"];
            break;
          case "프로":
            node.tags = ["STAR_1"];
            break;
            case "빌더":
              node.tags = ["STAR_2"];
              break;
            case "마스터":
              node.tags = ["STAR_3"];
              break;
            case "브론즈 마스터":
              node.tags = ["STAR_4"];
              break;
            case "실버 마스터":
              node.tags = ["STAR_5"];
              break;
            case "골드 마스터":
              node.tags = ["STAR_6"];
              break;
            case "블랙 마스터":
              node.tags = ["STAR_7"];
              break;
            case "비매출":
              node.tags = ["STAR_99"];
              break;
            }
          }

          this.chart = new OrgChart(document.getElementById("tree"), {
            nodeBinding: {
              img_0: "img",
              field_0: "아이디",
              field_1: "직급"
            },
            layout: "olivia",
            enableSearch: true,
            miniMap: true,
            collapse: {
              level: 3
            },
            nodes: this.nodes
          });
          this.show = false
        }
  },
  mounted(){
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = false;
    this.$store.state.isAbsolute = false;
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      }
    }
    this.GetTreeList();
  }
}
</script>

<style>

.node.STAR_0 rect {
    fill: #afafaf;
}
.node.STAR_1 rect {
    fill: #a9d08e;

}
.node.STAR_2 rect {
    fill: #a0c4cd;
}
.node.STAR_3 rect {
    fill: #f4848d;
}
.node.STAR_4 rect {
    fill: #6a54b3;
}
.node.STAR_5 rect {
    fill: #e1ad74;
}
.node.STAR_6 rect {
    fill: #ffd966;
}

.node.STAR_7 rect {
    fill: #38383b;
}

.node.STAR_99 rect {
    fill: #33c36c;
}


</style>
<style scoped>
  .boc-edit-form-instruments{
    display:none;
  }
</style>
